function HomepageController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var mainSlider;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	function initSlider(){
		var sliderConfig = {
			speed: 1000,
			autoplay: {
				delay: 6000
			},			
			pagination: {
				el: '.swiper-pagination .inner',
				clickable: true
			}
		};
		mainSlider = new Swiper('#main-slider', sliderConfig);		
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			
			// init
			initSlider();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
